import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/base/Button';

export default function Login() {
  const navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [loading, setLoading] = useState(false);
  
  const handleSendOTP = () => {
    if (phoneNumber.length >= 10) {
      setLoading(true);
      setTimeout(() => {
        setOtpSent(true);
        setLoading(false);
      }, 1500);
    }
  };
  
  const handleOtpChange = (index: number, value: string) => {
    if (value.length <= 1 && /^\d*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      
      if (value && index < 5) {
        const nextInput = document.getElementById(`otp-${index + 1}`);
        nextInput?.focus();
      }
    }
  };
  
  const handleVerifyOTP = () => {
    setLoading(true);
    setTimeout(() => {
      navigate('/onboarding');
    }, 1500);
  };
  
  return (
    <div className="relative h-screen bg-white flex flex-col">
      <div className="absolute top-0 left-0 right-0 h-48 bg-gradient-to-b from-[#E31837] to-transparent opacity-10"></div>
      
      <div className="relative z-10 flex-1 flex flex-col px-6 pt-16">
        <div className="mb-8">
          <img 
            src="https://public.readdy.ai/ai/img_res/92163c45-d441-4eec-8f6b-13c08dfd0d13.png" 
            alt="Domino's Logo" 
            className="w-20 h-20 object-contain mb-6"
          />
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Välkommen tillbaka</h1>
          <p className="text-base text-gray-600">Logga in för att börja leverera</p>
        </div>
        
        {!otpSent ? (
          <div className="space-y-6">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Telefonnummer
              </label>
              <div className="relative">
                <div className="absolute left-4 top-1/2 -translate-y-1/2 flex items-center gap-2">
                  <span className="text-base text-gray-700">🇸🇪</span>
                  <span className="text-base text-gray-700">+46</span>
                </div>
                <input
                  type="tel"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  placeholder="70 123 45 67"
                  className="w-full h-14 pl-24 pr-4 text-base border-2 border-gray-200 rounded-2xl focus:border-[#E31837] focus:outline-none"
                />
              </div>
            </div>
            
            <Button
              onClick={handleSendOTP}
              variant="primary"
              size="large"
              fullWidth
              loading={loading}
              disabled={phoneNumber.length < 10}
            >
              Skicka kod
            </Button>
            
            <div className="pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-600 text-center mb-3">
                Ny kurye?
              </p>
              <Button
                onClick={() => navigate('/signup')}
                variant="tertiary"
                size="large"
                fullWidth
              >
                Registrera dig som partner
              </Button>
            </div>
          </div>
        ) : (
          <div className="space-y-6">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Ange verifieringskod
              </label>
              <p className="text-sm text-gray-600 mb-4">
                Skickad till +46 {phoneNumber}
              </p>
              <div className="flex gap-2 justify-between">
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    id={`otp-${index}`}
                    type="text"
                    inputMode="numeric"
                    maxLength={1}
                    value={digit}
                    onChange={(e) => handleOtpChange(index, e.target.value)}
                    className="w-12 h-14 text-center text-xl font-bold border-2 border-gray-200 rounded-xl focus:border-[#E31837] focus:outline-none"
                  />
                ))}
              </div>
            </div>
            
            <Button
              onClick={handleVerifyOTP}
              variant="primary"
              size="large"
              fullWidth
              loading={loading}
              disabled={otp.some(d => !d)}
            >
              Verifiera
            </Button>
            
            <button
              onClick={() => setOtpSent(false)}
              className="w-full text-sm text-[#006491] font-semibold"
            >
              Ändra telefonnummer
            </button>
          </div>
        )}
      </div>
      
      <div className="px-6 pb-8">
        <p className="text-xs text-gray-500 text-center leading-relaxed">
          Genom att fortsätta godkänner du våra användarvillkor och integritetspolicy. 
          Vi behandlar dina personuppgifter enligt GDPR.
        </p>
      </div>
    </div>
  );
}
